/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingCheckoutBillingInterval =
    (typeof BuildingCheckoutBillingInterval)[keyof typeof BuildingCheckoutBillingInterval];

export const BuildingCheckoutBillingInterval = {
    Month: 1,
    Year: 2,
} as const;
